export type FAQSchemaType = {
  question: string;
  answer: string;
};

export const wantedFAQschema = [
  {
    question: 'Which movie is Wanted based on?',
    answer:
      'Wanted is based on a Telugu movie, Pokiri, directed by Prabhu Deva.'
  },
  {
    question: 'Where can I watch a Wanted movie?',
    answer: 'Wanted can be streamed on ZEE5, an OTT platform.'
  },
  {
    question: 'Who is Rajeev Shekhawat in the Wanted movie?',
    answer:
      'Rajeev Shekhawat is Radhe, who posed as a thug. He is an undercover cop working as a mole in a mafia gang.'
  },
  {
    question: 'Is Wanted a remake?',
    answer: 'Yes, it is a remake of a Telugu film.'
  },
  {
    question: 'What is the genre of the movie Wanted?',
    answer: 'Wanted falls under the action thriller genre.'
  },
  {
    question: 'Who is the director of Wanted movie?',
    answer: 'The film is directed by Prabhu Deva.'
  },
  {
    question: 'What are some famous dialogues from the Wanted movie?',
    answer:
      'Some of the famous dialogues from the movie are as follows: 1) Ek Baar Joh Maine Commitment Kardi....Uske Baad To Me Khud Ki Bhi Nahi Sunta. 2) Tu Ladki Ke Pichhe Bhagega,Ladki Paise Ke Pichhe Bhagegi.... Tu Paise Ke Pichhe Bhagega Ladki Tere Pichhe Bhageg'
  }
];

export const writerPadmabushanFAQschema = [
  {
    question: 'What is the name of the Writer Padmabhushan director?',
    answer: 'Shanmukha Prasanth is the director of Writer Padmabhushan.'
  },
  {
    question: 'Where can I watch the Writer Padmabhushan movie?',
    answer:
      'With a ZEE5 premium subscription, you can watch the movie on the streaming service.'
  },
  {
    question: 'What is the genre of the movie Writer Padmabhushan?',
    answer: 'Writer Padmabhushan is a comedy-drama movie.'
  },
  {
    question: 'What is the review for Writer Padmabhushan movie?',
    answer:
      'Writer Padmabhushan is an engaging film, and the movie received positive responses from the viewers. On IMDB, the film scored a rating of 8.3 out of 10.'
  }
];

export const rrrFAQschema = [
  {
    question: 'What is the name of the RRR director?',
    answer: 'The RRR film is directed by S S Rajamouli.'
  },
  {
    question: 'Who is the composer of Naatu Naatu Song?',
    answer:
      'MM Keeravani composed the Naatu Naatu song and picturized actors Jr NTR and Ram Charan.'
  },
  {
    question: 'What did Naatu Naatu win?',
    answer:
      'Naatu Naatu won the Oscar Award 2023 and the prestigious Golden Globe Award (Category - Best Original Song).'
  },
  {
    question: 'Who choreographed Naatu Naatu song?',
    answer:
      'The steps to the Naatu Naatu song were choreographed by Prem Rakshith.'
  }
];

export const SirfEkBandaaKaafiHaiFAQschema = [
  {
    question: 'Who is the producer of Sirf Ek Bandaa Kaafi Hai?',
    answer: 'Vinod Bhanushali is the producer of Sirf Ek Bandaa Kaafi Hai.'
  },
  {
    question: 'Who gave the Background music for Sirf Ek Bandaa Kaafi Hai?',
    answer: 'Sandeep Chowta provided the background music for the Bandaa movie.'
  },
  {
    question: 'What is the age limit for this film?',
    answer: 'Anyone above the age of 16 is allowed to watch this film..'
  }
];

export const VenkateshDaggubattiFAQschema = [
  {
    question: "Which film marked Venkatesh's acting debut?",
    answer:
      'Venkatesh made his acting debut in 1986 with the film "Kaliyuga Pandavulu."'
  },
  {
    question:
      'Is Venkatesh Daggubati related to any other actors in the film industry?',
    answer:
      'Venkatesh Daggubati comes from a prominent film family in India. His father, Ramanaidu Daggubati, was a renowned film producer, and his brother, Suresh Babu, is also a well-known film producer and distributor.'
  },
  {
    question: 'Has Venkatesh won any awards for his performances?',
    answer:
      'Venkatesh Daggubati has received several awards and accolades for his exceptional performances. He has won multiple Nandi Awards, Filmfare Awards, and CineMAA Awards, among others, for his outstanding contributions to Telugu cinema.'
  },
  {
    question: 'Has Venkatesh acted in movies from other film industries?',
    answer:
      'While Venkatesh primarily works in the Telugu film industry, he has also appeared in a few Tamil films. One notable Tamil film he starred in is "Annamalai," opposite Rajinikanth.'
  },
  {
    question:
      'Does Venkatesh Daggubati experiment with different genres in his movies?',
    answer:
      'Venkatesh is known for his versatility and has experimented with various genres throughout his career. He has excelled in family dramas, romantic comedies, action thrillers, and even intense character-driven films, showcasing his ability to adapt to diverse roles and genres.'
  }
];

export const KisiKaBhaiKisikiJaanFAQschema = [
  {
    question: 'How many songs are there in Kisi Ka Bhai Kisi Ki Jaan?',
    answer: 'There are eight songs in the Kisi Ka Bhai Kisi Ki Jaan movie.'
  },
  {
    question: 'What is the genre of Kisi Ka Bhai Kisi Ki Jaan?',
    answer:
      'Kisi Ka Bhai Kisi Ki Jaan combines action, drama, thriller and comedy.'
  },
  {
    question: 'What is the runtime of Kisi Ka Bhai Kisi Ki Jaan movie?',
    answer: 'Kisi Ka Bhai Kisi Ki Jaan is 144 minutes long.'
  },
  {
    question: 'In what language is Kisi Ka Bhai Kisi Ki Jaan released?',
    answer: 'Kisi Ka Bhai Kisi Ki Jaan movie is released in the Hindi language.'
  }
];

export const Gadar2FAQschema = [
  {
    question: 'Where to watch Gadar 2?',
    answer:
      'Gadar 2 will make its digital debut on October 6, 2023, on ZEE5 OTT Platform.'
  },
  {
    question: 'Who plays the role of Tara Singh in Gadar 2?',
    answer: 'Sunny Deol plays the role of Tara Singh in the movie.'
  },
  {
    question: 'Who is the director of Gadar 2?',
    answer: 'Anil Sharma is the director of the Gadar 2 movie.'
  },
  {
    question: 'Who are the main actors and actresses in Gadar 2?',
    answer:
      'Sunny Deol, Ameesha Patel, Utkarsh Sharma, and Hamid Iqbal play lead roles in the war movie.'
  },
  {
    question: 'Who is Sunny’s son in the movie?',
    answer:
      'Actor Utkarsh Sharma plays the roles of Charanjeet Singh, son of Sunny’s character, Tara Singh, and Sakeena, played by Ameesha Patel.'
  },
  {
    question: 'Who is the villain in Gadar 2?',
    answer:
      'Actor Manish Wadhwa will be portraying Hamid Iqbal, the villainous character in Gadar 2.'
  },
  {
    question: 'Will there be a handpump scene in Gadar 2?',
    answer:
      'Yes, the iconic handpump scene is one of the highlights of Gadar 2.'
  },
  {
    question: 'Which songs of Gadar movie will make a comeback in Gadar 2?',
    answer:
      'Main Nikla Gaddi Leke” and “Udd Jaa Kaale Kaave” are popular songs from Gadar: Ek Prem Katha and have been recreated by music director Mithoon for Gadar 2.'
  },
  {
    question: 'What genre does Gadar 2 belong to?',
    answer: 'Gadar 2 is an action-drama movie.'
  },
  {
    question: 'In which language will the movie be available?',
    answer: 'Gadar movie will be available to stream in Hindi.'
  }
];
export const GhoomerFAQschema = [
  {
    question: 'Where to watch Ghoomer movie?',
    answer: 'You can watch Ghoomer movie on November 10, 2023, on ZEE5.'
  },
  {
    question: 'What genre does Ghoomer movie belong to?',
    answer: 'Ghoomer is a sports drama film.'
  },
  {
    question: 'Who is the director of Ghoomer Movie?',
    answer: 'Ghoomer movie is directed by R. Balki.'
  },
  {
    question: 'Who are the main actors and actresses in Ghoomer movie?',
    answer:
      'Abhishek Bachchan, Saiyami Kher, Shabana Azmi, and Angad Bedi play lead roles in the movie.'
  },
  {
    question: 'Does Amitabh Bachchan have a prominent role in Ghoomer?',
    answer:
      'Amitabh Bachchan does a cameo as a commentator in the latter part of the film.'
  },
  {
    question: 'What is the review for Ghoomer movie?',
    answer:
      'Ghoomer was widely appreciated by Indian and overseas media, with Indian cricket legends like – Sachin Tendulkar, Kapil Dev, Yuvraj Singh and others also expressing their admiration.'
  },
  {
    question: 'What is the runtime of Ghoomer movie?',
    answer: 'The runtime for the Ghoomer film is 2 hours and 15 minutes.'
  }
];

export const KadakSinghFAQschema = [
  {
    question: 'Who is the director of Kadak Singh?',
    answer: 'Kadak Singh is directed by Aniruddha Roy Chowdhury.'
  },
  {
    question: 'Who are the actors in Kadak Singh?',
    answer:
      'The movie stars Pankaj Tripathi, Parvathy Thiruvothu, Sanjana Sanghi, Jaya Ahsan, Dilip Shankar, Jogi Mallang, Raajan Modi, Paresh Pahuja, Varun Buddhadev, Anindya Sengupta, and Gulshanara Khatun in the lead roles.'
  },
  {
    question: 'What is the role of Pankaj Tripathi in Kadak Singh movie?',
    answer:
      'Pankaj Tripathi plays the lead role of AK Shrivastav, an officer of the Department of Financial Crimes, who suffers from retrograde amnesia.'
  },
  {
    question: 'How to watch Kadak Singh in HD?',
    answer:
      'You can watch Kadak Singh movie in HD on ZEE5 after its release on December 8, 2023.'
  },
  {
    question: 'What genre does Kadak Singh belong to?',
    answer: 'Kadak Singh is a thriller-drama movie.'
  },
  {
    question: 'Who is the writer of Kadak Singh?',
    answer:
      'Aniruddha Roy Chowdhury, Viraf Sarkari, and Ritesh Shah are the movie’s writers.'
  }
];
export const tejasMovieFAQschema = [
  {
    question: 'What is Tejas movie inspired by?',
    answer:
      "Kangana Ranaut's 'Tejas' features a dialogue inspired by Prime Minister Narendra Modi, as acknowledged by the actress."
  },
  {
    question: 'Is Tejas based on a true story?',
    answer:
      '"Tejas," directed and written by Sarvesh Mewara, is a fictional tale about a courageous female fighter pilot undertaking daring missions.'
  },
  {
    question: 'Why is Tejas famous?',
    answer:
      'The LCA Tejas is renowned for its advanced digital avionics and composite structures. It is the lightest and most miniature supersonic combat aircraft in its class, capable of carrying eight to nine tonnes.'
  }
];
export const samBahadurMovieFAQschema = [
  {
    question: 'Is Sam Bahadur a true story?',
    answer:
      '"Sam Bahadur" is based on a true story. It\'s a biopic depicting Field Marshal Sam Manekshaw, one of India\'s most celebrated military leaders.'
  },
  {
    question: 'Is Sam Bahadur available on OTT?',
    answer:
      'Yes, "Sam Bahadur" is available on the OTT platform ZEE5, having been released on January 26, 2024.'
  },
  {
    question: "Who was Sam Bahadur's friend in Pakistan?",
    answer:
      "Sam Bahadur and Pakistan's General Yahya Khan, once friends at the Indian Military Academy, became foes in the 1971 India-Pakistan War."
  },
  {
    question: 'Was Sam Bahadur Indian?',
    answer:
      'Yes, Sam Bahadur, whose real name was Field Marshal Sam Hormusji Framji Jamshedji Manekshaw, was Indian.'
  }
];

export const Khichdi2MovieFAQschema = [
  {
    question: 'Where was Khichdi 2 filmed?',
    answer:
      '"Khichdi 2: Mission Paanthukistan" was filmed in Mumbai, offering a scenic backdrop to this comedic adventure.'
  },
  {
    question: 'Who is the Wazir in Khichdi 2?',
    answer:
      "Reyaansh Vir Chadha brings the character of Wazir to life, adding a unique twist to the film's plot."
  },
  {
    question: 'Is Khichdi a movie or serial?',
    answer:
      '"Khichdi" began as a beloved television series before transitioning into the cinematic world with "Khichdi: The Movie" in 2010.'
  },
  {
    question: 'Where can I watch Khichdi 2 movie?',
    answer:
      'You can watch "Khichdi 2: Mission Paanthukistan" on ZEE5, starting February 9, as it arrives on the OTT platform.'
  }
];
export const theKeralaStoryFAQschema = [
  {
    question: 'Is The Kerala Story on OTT?',
    answer:
      'Yes. "The Kerala Story" will be available on the OTT platform ZEE5 starting February 16, 2024.'
  },
  {
    question: 'Is The Kerala story a true story?',
    answer:
      '"The Kerala Story" is a fictional narrative based on controversial claims and not directly on documented facts.'
  },
  {
    question: 'What is the film The Kerala Story based on?',
    answer:
      '"The Kerala Story" is a fictional movie about three women from Kerala drawn into joining the Islamic State after converting to Islam, told through a story that has sparked much debate.'
  }
];
export const mainAtalHoonFAQschema = [
  {
    question: 'Q1. What is the movie Main Atal Hoon about?',
    answer:
      "Main Atal Hoon tells the story of Atal Bihari Vajpayee, a much-loved political leader in India. The film portrays his personal life and the impact he had on the country's political landscape."
  },
  {
    question: 'Q2. Who played Advani in Main Atal Hoon?',
    answer:
      'Actor Raja Rameshkumar Sevak plays the role of Lal Krishna Advani in the movie.'
  },
  {
    question: 'Q3. What is the IMDb rating of Main Atal Hoon?',
    answer: 'The Hindi movie received an IMDb rating of 7.3/10.'
  },
  {
    question: 'Q4. Who is the director of the Main Atal Hoon movie?',
    answer: 'Ravi Jadhav is the director of Main Atal Hoon.'
  },
  {
    question: 'Q5. Which genre does Main Atal Hoon belong to?',
    answer: 'Main Atal Hoon is a biopic drama movie.'
  },
  {
    question: 'Q6. Who are the lead actors in Main Atal Hoon?',
    answer: 'Main Atal Hoon movie stars Pankaj Tripathi in the lead role.'
  },
  {
    question: 'Q7. Where to watch the movie?',
    answer: 'Main Atal Hoon will premiere online on ZEE5 on March 14, 2024.'
  },
  {
    question: 'Q8. What is the run time of the movie?',
    answer: 'The runtime of Main Atal Hoon is 2 hours and 19 minutes.'
  },
  {
    question: 'Q9. Are there in any songs in the movie?',
    answer:
      'The film has three songs: Ankaha (Romantic song by Shreya Ghoshal & Armaan Malik), Desh Pehle (Singer - Jubin Nautiyal | Composer – Payal Dev), Ram Dhun (Composed and Sung by Kailash Kher)'
  }
];
export const hanuManMovieFAQschema = [
  {
    question: 'What is the HanuMan movie about?',
    answer:
      'Hanu-Man follows the journey of Hanu-Manthu, a young man bestowed with the power of Lord Hanu-Man, as he battles against oppression and discovers his true purpose as an Indian superhero. Meanwhile, we see Micheal, a “superhero” from Mumbai, who seemingly turns evil in his hunger for power. What happens when these two formidable powers clash, forms the rest of the story.'
  },
  {
    question: 'Is the HanuMan movie a remake?',
    answer:
      'No, Hanu-Man is an original Telugu-language superhero film directed by Prasanth Varma starring Teja Sajja in the titular role.'
  },
  {
    question: 'In which language is the Hanu-Man movie released on ZEE5?',
    answer:
      'The Hanu-Man movie is released in its original language which is Telugu on ZEE5.'
  },
  {
    question: 'Who is the director of the Hanu Man movie?',
    answer:
      'The movie is written and directed by ace director Prasanth Varma, making this the first installment of the Prasanth Varma Cinematic Universe (PVCU).'
  },
  {
    question: 'What genre does the Hanu Man movie belong to?',
    answer:
      'Hanu-Man belongs to the superhero fantasy genre with elements of mythology and action.'
  },
  {
    question: 'Where can I watch the Hanu-Man movie in the Telugu language?',
    answer:
      'Hanu-Man movie is available for streaming in its original language Telugu on ZEE5 across the globe.'
  },
  {
    question: 'What are the Hanu-Man movie reviews?',
    answer:
      'Hanu-Man movie reviews have been extremely positive. Both critics and audiences have praised the film for its direction, performances, visuals, and engaging storyline, earning it positive reviews across various platforms.'
  },
  {
    question: 'What is the IMDb rating of this Hanu-Man movie?',
    answer:
      'The IMDb rating of Hanu-Man is a phenomenal 8.4 out of 10, clearly reflecting the raving reviews it has received from both, critics and audiences alike.'
  }
];
